module.exports = __webpack_public_path__ + "static/img/environment_02_h5.56011c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/environment_02_h5.png
// module id = HBup
// module chunks = 34